import React from "react";
import { Button, Card, Col } from "react-bootstrap";
import { UserTable } from "../allTables/allTable";
import UserService from "../../services/user.service";
import { useEffect } from "react";
import { useState } from "react";
import { CSVLink } from "react-csv";
import moment from "moment";
import useDialogState from "../../hooks/useDialog";
import { useFormik } from "formik";
import { UsreEdit } from "../modals/allModal";
import CountryService from "../../services/country.service";
import * as yup from "yup";
import CountryCodeService from "../../services/countryCode.service";
import { useSnackbar } from "notistack";

const schema = yup.object().shape({
  userName: yup.string().required("Please Enter User Name"),
  password: yup.string().required("Please Enter Password"),
  firstName: yup.string().required("Please Enter First Name"),
  lastName: yup.string().required("Please Enter Last Name"),
  nationality: yup.string().required("Please Select Nationality"),
});

export function DashboardTable() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRows, setTotalRows] = useState("");
  const [search, setSearch] = useState("");
  const [listData, setListData] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [changes, setChanges] = useState({});
  const [update, setUpdate] = useState(false);
  const [loader, setLoader] = useState(false);
  const [countryCodeList, setCountryCodeList] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const getAllUserData = async () => {
    setIsLoading(true);
    try {
      const response = await UserService.getAllUser(
        search,
        pageNumber,
        dataPerPage
      );
      setTotalRows(response.data.totalCount);
      setData(response.data.data);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getAllUserDataList = async () => {
    const response = await UserService.getAllUserList();
    setListData(response.data.data);
  };

  const getAllCountry = async () => {
    const response = await CountryService.GetCountryListdrpdown();
    setCountryList(response.data.data);
  };

  const ContryStatus = countryList.map((user) => ({
    value: user.countryName,
    label: user.countryName,
  }));

  useEffect(() => {
    getAllUserDataList();
    getAllCountry();
  }, []);

  useEffect(() => {
    getAllUserData();
  }, [search, pageNumber, dataPerPage]);

  const handlePerPageChange = async (newPerPage, newPageNumber) => {
    setIsLoading(true);
    setDataPerPage(newPerPage);
    setPageNumber(newPageNumber);
    await getAllUserData();
    setIsLoading(false);
  };
  const handlePageChange = async (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    await getAllUserData();
    setIsLoading(false);
  };

  const handleData = (e) => {
    setSearch(e.target.value);
  };

  const headers = [
    { label: "Unique Code", key: "uniqueCode" },
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "User Name", key: "userName" },
    { label: "Mobile Number", key: "mobileNumber" },
    { label: "Email", key: "email" },
    { label: "Role", key: "roles" },
    { label: "createdAt", key: "createdAt" },
    { label: "instagramLink", key: "socialDetails[0].instagramAccount" },
    { label: "redditLink", key: "socialDetails[0].redditAccount" },
    { label: "Xlink", key: "socialDetails[0].Xaccount" },
  ];

  const initialValue = {
    userName: "",
    password: "",
    firstName: "",
    lastName: "",
    roles: "",
    email: "",
    countryCode: "",
    mobileNumber: "",
    nationality: "",
    socialDetails: [],
  };

  const contryStatus = [
    {
      value: "admin",
      label: "Admin",
    },
    {
      value: "user",
      label: "User",
    },
  ];

  const changeStatus = (value) => {
    formik.setFieldValue("roles", value.value);
    handleFieldChange("roles", value.value);
  };

  const {
    open: modalShows,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();

  const handleOpen = async (id) => {
    handleDialogOpen();
    if (id) {
      setUpdate(true);
      const response = await UserService.GetUser(id);
      const result = response.data.data;
      formik.setFieldValue("userId", result._id);
      formik.setFieldValue("userName", result.userName);
      formik.setFieldValue("firstName", result.firstName);
      formik.setFieldValue("lastName", result.lastName);
      formik.setFieldValue("roles", result.roles);
      formik.setFieldValue("nationality", result.nationality);
    } else {
      setUpdate(false);
      formik.resetForm();
      formik.setFieldValue("roles", "user");
    }
  };

  const handleFieldChange = (fieldName, value) => {
    setChanges({ ...changes, [fieldName]: value });
  };

  const submit = async (values, action) => {
    if (values.userId) {
      try {
        setLoader(true);
        await UserService.UserUpdate({
          ...values,
          ...changes,
          userId: values.userId,
        });
        setLoader(false);
        handleDialogClose();
        getAllUserData();
        action.resetForm();
        enqueueSnackbar("User updated successfully!", { variant: "success" });
      } catch (error) {
        console.error("update user error", error);
        enqueueSnackbar(
          `Something went wrong! :${error.response.data.message}`,
          { variant: "error" }
        );
        setLoader(false);
      } finally {
        setChanges({});
      }
    } else {
      try {
        setLoader(true);
        await UserService.AddUser(values);
        setLoader(false);
        handleDialogClose();
        getAllUserData();
        action.resetForm();
        enqueueSnackbar("User Created successfully!", { variant: "success" });
      } catch (error) {
        console.error("create user error", error);
        enqueueSnackbar(
          `Something went wrong! :${error.response.data.message}`,
          { variant: "error" }
        );
        setLoader(false);
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: !update && schema,
    onSubmit: submit,
  });

  const handleChange = (e) => {
    formik.setFieldValue("nationality", e.label);
    setChanges({ ...changes, nationality: e.label });
  };

  const getCountryCode = async () => {
    const response = await CountryCodeService.getAllCountry();
    setCountryCodeList(response.data.data);
  };

  const CountryCode = countryCodeList.map((user) => ({
    value: user.countryCode,
    label: (
      <div style={{ textAlign: "start" }}>
        <img
          src={user.countryImage}
          alt={`Flag for ${user.countryCode}`}
          style={{ marginRight: "8px", maxHeight: "20px" }}
        />
        <span>{user.countryCode}</span>
      </div>
    ),
  }));

  useEffect(() => {
    getCountryCode();
  }, []);

  const changeCountryCode = (e) => {
    formik.setFieldValue("countryCode", e.value);
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Users
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fa fa-user icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalRows}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col sm={12} md={6} lg={6} xl={6} className="ms-auto mt-auto">
          <div
            className="custom-card text-end  pointer"
            style={{ marginRight: "18px" }}>
            {listData?.length > 0 && !isLoading ? (
              <CSVLink
                data={listData.map((item) => ({
                  ...item,
                  createdAt: moment(item.createdAt).format("DD-MM-YYYY"),
                  instagramLink: item.socialDetails[0]?.instagramAccount,
                  redditLink: item.socialDetails[0]?.redditAccount,
                  Xlink: item.socialDetails[0]?.Xaccount,
                }))}
                headers={headers}
                filename={"users.csv"}>
                <Button
                  className="text-white"
                  style={{ marginBottom: "5px", marginLeft: "15px" }}>
                  <i className="fas fa-download"></i> &nbsp; Download User List
                </Button>
              </CSVLink>
            ) : (
              <Button
                className="text-white"
                disabled
                style={{ marginBottom: "5px", marginLeft: "15px" }}>
                <i className="fas fa-download"></i> &nbsp; Download User List
              </Button>
            )}

            <Button
              className="text-white"
              onClick={() => handleOpen("")}
              style={{ marginBottom: "5px", marginLeft: "15px" }}>
              <i className="fas fa-plus"></i> &nbsp; Add User
            </Button>
          </div>
        </Col>
      </div>
      <UserTable
        data={data}
        totalRows={totalRows}
        dataPerPage={dataPerPage}
        handlePerPageChange={handlePerPageChange}
        handlePageChange={handlePageChange}
        isLoading={isLoading}
        getAllUser={getAllUserData}
        handleData={handleData}
        modalShows={modalShows}
        formik={formik}
        handleFieldChange={handleFieldChange}
        handleOpen={handleOpen}
      />
      {modalShows && (
        <UsreEdit
          show={handleDialogOpen}
          onHide={handleDialogClose}
          loader={loader}
          formik={formik}
          contryStatus={contryStatus}
          changeStatus={changeStatus}
          CountryCode={CountryCode}
          // openCity={openCity}
          // handleCloseCity={handleCloseCity}
          // handleOpenCity={handleOpenCity}
          // openCity2={openCity2}
          // handleCloseCity2={handleCloseCity2}
          changeCountryCode={changeCountryCode}
          handleFieldChange={handleFieldChange}
          CountryStatus={ContryStatus.reverse()}
          handleChange={handleChange}
          update={update}
        />
      )}
    </>
  );
}
